import { zPayPaymentMethodForm, zPayCreateCardForm } from "zoox-components";
import CardService from "@/service/card-service";
import OrderService from "@/service/order-service";
import PaymentService from "@/service/payment-service";
import CreateCardDialog from "@/components/shared/CreateCardDialog";
import PersonService from "@/service/person-service";
import { CustomHeadersService } from "zoox-infra";
import CreditCard from "../CreditCard";

export default {
  name: "PaymentMethods",
  components: {
    zPayPaymentMethodForm,
    "z-pay-create-card-form": zPayCreateCardForm,
    CreateCardDialog,
    CreditCard
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    currentGuest: {
      type: Object,
      default: () => ({})
    },
    charge: {
      type: Object,
      default: () => ({})
    },
    personId: {
      type: String,
      default: null
    },
    person: {
      type: Object,
      default: () => ({})
    },
    loadingPayButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cardService: null,
      orderService: null,
      paymentService: new PaymentService(),
      personService: new PersonService(),
      cards: [],
      selectedCards: [],
      debits: [],
      totalPayment: 0,
      showLoading: true,
      acceptedMultiPayments: false,
      showCreateCardDialog: false,
      watchedCharge: null,
      render: true,
      creatingCard: false
    };
  },
  watch: {
    charge(val) {
      this.watchedCharge = val;
      this.render = false;
      this.render = true;
    }
  },
  async created() {
    this.watchedCharge = this.charge;
    if (CustomHeadersService.getCustomHeaders().Authorization) {
      let data = {
        id: this.currentGuest.personId || this.personId,
        name: this.currentGuest.name,
        token: CustomHeadersService.getCustomHeaders().Authorization
      };
      this.personService.setLoginData(data);
    }
    this.cardService = new CardService();
    this.orderService = new OrderService();
  },
  async mounted() {
    this.showLoading = false;

    const cardsData = await this.cardService.getCards();
    this.cards = cardsData.map(c => {
      const newCard = c;
      newCard.acquirer.acceptInstallments =
        c.acquirer.acceptInstallments &&
        this.watchedCharge.metadata.type !== "warranty_registration";

      return newCard;
    });
    if (this.cards && this.cards[0] && this.cards[0].acceptedMultiPayments) {
      this.acceptedMultiPayments =
        this.cards[0].acceptedMultiPayments.length > 0;
    }

    let itemsIds = [];
    this.watchedCharge.items.forEach(function(item) {
      itemsIds.push(item.id);
    });
    let items = [];
    if (!this.orderService) this.orderService = new OrderService();
    items = await this.orderService.getBulkItems(itemsIds);

    items.forEach(item => {
      const percentLeft = item.percentLeft || 100;
      const itemValue = (item.amount * item.quantity * percentLeft) / 100;
      this.debits.push({
        name: item.description,
        price: itemValue
      });
    });
    this.selectFirstByDefault();
  },
  methods: {
    setThemeStyle() {
      // REMOVE A CLASSE P/ CORRIGIR O TEMA DE CORES DINÂMICAS DO BOTÃO
      // IMPORTANTE: FORA INSERIDO POR ALGUEM ESTA CLASSE "ORANGEBTN", E ELA ESTILIZA O BOTÃO NO CP-MOBILE
      // POR CONTA DISTO ESTAVA SOBREPONDO O TEMA DO PORTAL.. É GAMBIARRA, MAS FAZER O QUE NÉ?
      setTimeout(() => {
        const submitBtn = document.getElementById("submitPaymentMethodForm");

        if (submitBtn) {
          submitBtn.classList.remove("orangeBtn");
        }
      });
    },
    backStep() {
      if (this.creatingCard) {
        this.creatingCard = !this.creatingCard;
      } else {
        this.$emit("goback");
      }
    },
    async deleteCard(card) {
      this.showLoading = true;
      await this.cardService.deleteCard(card.gatewayCardId).then(async () => {
        this.cards = await this.cardService.getCards();
        this.selectFirstByDefault();
        this.showLoading = false;
      });
    },
    addCard() {
      this.creatingCard = true;
    },
    async cardCreated() {
      const cardsData = await this.cardService.getCards();
      this.creatingCard = false;
      this.cards = cardsData;
      this.showLoading = false;
      this.treatCreatedCards();
    },
    async treatCreatedCards() {
      this.selectedCards = [];
      await this.cardService.getCards().then(resp => {
        this.cards = resp;
        this.selectFirstByDefault();
      });
    },
    closeCardDialog() {
      this.creatingCard = false;
    },
    Pay() {
      let charge = this.watchedCharge;
      let chargesToPay = [];
      const cardsToPay = this.cards.filter(card => {
        return (
          this.selectedCards.indexOf(
            `${card.firstSixDigits}-${card.lastFourDigits}`
          ) !== -1
        );
      });
      cardsToPay.forEach(card => {
        const newCharge = { ...charge };
        newCharge.id = charge.id;
        if (card.paymentValue && card.paymentValue > 0) {
          let operationType = "auth_and_capture";
          if (newCharge.metadata.type === "warranty_registration") {
            operationType = "auth_only";
          }

          newCharge.method = "creditCard";
          newCharge.creditCard = {
            cardId: card.gatewayCardId,
            operation: operationType,
            installments: 1
          };

          newCharge.metadata = {
            chargeId: charge.id,
            origin: "at_checkin",
            type: "warranty_registration"
          };
          newCharge.customer = {
            name: this.currentGuest.name,
            email: this.currentGuest.email,
            id: this.personId
          };
          newCharge.amount = card.paymentValue;
          chargesToPay.push(newCharge);
        }
      });
      this.$emit("submit-pay", {
        orderId: charge.order.id,
        chargeId: charge.id,
        chargesToPay
      });
    },
    allowsInstallmentPayment: function(card) {
      let allowed = false;
      if (card.acquirer && card.acquirer.acceptInstallments) {
        allowed = true;
      }

      return allowed;
    },
    selectFirstByDefault() {
      if (this.cards.length > 0) {
        if (this.acceptedMultiPayments) {
          var checkBox = document.querySelector(
            "#checkBox div div div div input"
          );
          checkBox.click();
        } else {
          var radio = document.querySelector("#radio div div input");
          radio.click();
        }
      }
    },
    cardChecked(value) {
      if (value) {
        this.selectedCards = [value];
      }
      this.setThemeStyle();

      const totalAmountInHundredths = Math.round(this.value * 100);
      const restInHundredths =
        totalAmountInHundredths % this.selectedCards.length;
      const totalAmountWithoutRest =
        (totalAmountInHundredths - restInHundredths) / 100;
      const rest = restInHundredths / 100;
      let paymentValue = totalAmountWithoutRest / this.selectedCards.length;
      let self = this;
      self.totalPayment = 0;
      let firstCardSelected = null;
      this.cards.forEach((card, index) => {
        if (
          self.selectedCards.includes(
            `${card.firstSixDigits}-${card.lastFourDigits}`
          )
        ) {
          if (firstCardSelected === null) {
            firstCardSelected = index;
            card.paymentValue = paymentValue + rest;
          } else {
            card.paymentValue = paymentValue;
          }
          self.totalPayment =
            (self.totalPayment * 100 + card.paymentValue * 100) / 100;
        }
        card.iterationOptions = self.updateIterationsOptions(card);
        card.paymentIterations = card.iterationOptions[0];
      });
    },
    changeCardValue(card) {
      card.iterationOptions = this.updateIterationsOptions(card);
      card.paymentIterations = card.iterationOptions[0];

      let self = this;
      let changedCard = card;
      self.totalPayment = 0;

      if (self.selectedCards.length === 2) {
        this.cards.forEach(function(card) {
          if (
            `${card.firstSixDigits}-${card.lastFourDigits}` !==
              `${changedCard.firstSixDigits}-${changedCard.lastFourDigits}` &&
            self.selectedCards.includes(
              `${card.firstSixDigits}-${card.lastFourDigits}`
            ) &&
            changedCard.paymentValue < self.value &&
            changedCard.paymentValue > 0
          ) {
            card.paymentValue = self.value - changedCard.paymentValue;
            card.iterationOptions = self.updateIterationsOptions(card);
            card.paymentIterations = card.iterationOptions[0];
          }
        });
      }

      this.cards.forEach(function(card) {
        if (
          self.selectedCards.includes(
            `${card.firstSixDigits}-${card.lastFourDigits}`
          )
        )
          self.totalPayment =
            (self.totalPayment * 100 + card.paymentValue * 100) / 100;
      });

      this.$forceUpdate();
    },
    formatCurrency(amount) {
      if (isNaN(amount) || amount === "") {
        return "";
      } else {
        return amount.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    installmentFeeText(currentInstallment, limitInstallment) {
      if (currentInstallment >= limitInstallment) {
        return ` / com juros`;
      } else {
        return ` / sem juros`;
      }
    },
    calcAmountWithFee(currentInstallment, limitInstallment, fee, paymentValue) {
      if (currentInstallment >= limitInstallment) {
        const calcFee = (1 + fee / 100) ** currentInstallment;
        return Math.round(paymentValue * calcFee * 100) / 100;
      } else {
        return paymentValue;
      }
    },
    updateIterationsOptions(card) {
      const iterationOptions = [];
      for (let i = 1; i <= card.acquirer.maxInstallments; i++) {
        let installmentFeeText;
        let amountWithFee;
        const limitInstallment = card.acquirer.installmentsFee.find(
          ({ fee }) => fee !== 0
        );
        if (limitInstallment) {
          installmentFeeText = this.installmentFeeText(
            i,
            limitInstallment.installment
          );
          amountWithFee =
            Math.round(
              (this.calcAmountWithFee(
                i,
                limitInstallment.installment,
                limitInstallment.fee,
                card.paymentValue
              ) *
                100) /
                i
            ) / 100;
        } else {
          installmentFeeText = ` / ${this.$t("PAYMENT_SOLICITATION.NO_FEE")}`;
          amountWithFee = Math.round((card.paymentValue * 100) / i) / 100;
        }
        const formatedAmountWithFee = this.formatCurrency(amountWithFee);
        if (
          i === 1 ||
          Math.round(card.paymentValue * 100) / i >=
            Math.round(card.acquirer.minPerInstallment * 100)
        ) {
          iterationOptions.push({
            text: `${i} x ${formatedAmountWithFee}${installmentFeeText}`,
            value: i
          });
        }
      }

      return iterationOptions;
    }
  }
};
